export default __webpack_public_path__ + "static/media/TopRightEllipse.a89d8e72.svg";